import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Job } from "../../services/job/job.interface";
import JobDetail from "./job-detail";

export interface JobContentProp {
  jobs: Job[];
  tabIndex?: number;
}
export default function JobContent({
  jobs,
  tabIndex,
}: JobContentProp) {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const isActiveTab = (i: number) => i === activeTabIndex ? ' tab-active' : '';

  useEffect(() => {
    setActiveTabIndex(tabIndex ?? 0);

  }, [tabIndex]);

  return (
    <>
      <div className="kv">
        <img src="/images/top-kv.jpg" alt="kv" />
        <div className="kv-content">
          <h2>HOSHINOでは<br className="sp" />世界に誇るものづくり業界への関心を持つ方を<br />広く募集しております。</h2>
          <p className="description">
            「本当に質の良いものを、長く愛する。」<br />
            靴の新たな価値観を提案し、<br className="sp" />
            多くのお客様からご支持を頂いているHOSHINO。<br />
            今後は東京の店舗を飛び出し、<br className="sp" />
            日本国内の各地方や<br className="sp" />
            海外でのイベントも控えております。<br />
            次のフェーズへと移行するHOSHINOにて、<br className="sp" />
            共にものづくりに携わりませんか。<br />
            靴職人の専門学校に通っていらっしゃる方以外にも、未経験者の方もご相談承ります。<br />
            また、販売職の募集も受付中です。
          </p>
        </div>
      </div>
      <div className="tabs">
      {jobs.map((job, i) => job.visible && (
        <div
          key={`job-tab_${i}`}
          className={`tab${isActiveTab(i)}`}
        >
          <Link to={`/job/${job.type}`}>
            <span className="title">{job.nameJp}</span>
            <span className="sub-title">{job.name}</span>
          </Link>
        </div>
      ))}
      </div>
      <div className="tab-content">
      {jobs.map((job, i) => job.visible && activeTabIndex === i && (
        <JobDetail key={job.name} job={job} />
      ))}
      </div>
    </>
  );
}